import React from 'react';
import { Spinner } from 'reactstrap';
import { Breadcrumb } from "../../../components/Common";
import { useCashFlow } from './hooks/useCashFlow';
import { CashFlowTable } from './components/CashFlowTable';

/**
 * CashFlowPage
 * Fluxo de Caixa Projetado — card único (mesmo padrão de Receivables).
 */
const CashFlowPage = () => {
    document.title = "Fluxo de Caixa Projetado | NeoApp - Sistema de Gestão";

    const {
        startDate,
        setStartDate,
        endDate,
        setEndDate,
        bankAccounts,
        currentTotalBalance,
        projectedDays,
        loading,
    } = useCashFlow();

    return (
        <React.Fragment>
            {/* ═══ HEADER ═══ */}
            <div className="d-flex align-items-center justify-content-between mb-3">
                <Breadcrumb title="Fluxo de Caixa" />
            </div>

            <div className="border-top mb-3"></div>

            {/* ═══ LOADING INICIAL ═══ */}
            {loading && !projectedDays.length && (
                <div className="text-center py-5">
                    <Spinner color="primary" />
                    <p className="text-muted mt-2">Carregando fluxo de caixa...</p>
                </div>
            )}

            {/* ═══ CARD ÚNICO ═══ */}
            {(!loading || projectedDays.length > 0) && (
                <CashFlowTable
                    projectedDays={projectedDays}
                    loading={loading}
                    startDate={startDate}
                    endDate={endDate}
                    onStartDateChange={(val) => setStartDate(val)}
                    onEndDateChange={(val) => setEndDate(val)}
                    currentTotalBalance={currentTotalBalance}
                    bankAccountsCount={bankAccounts.length}
                />
            )}
        </React.Fragment>
    );
};

export default CashFlowPage;
